import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import V1App from "@/v1/V1App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <V1App />
  </React.StrictMode>,
);
